import { useState, useEffect } from "react";
import api from "../Api";
import { useAuth } from "../context/authcontext";

export function useIsVoormanOnAnyProject() {
    const { auth } = useAuth();
    const [isVoorman, setIsVoorman] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!auth.userId) {
            setIsVoorman(false);
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get(`/users/${auth.userId}/projects`)
            .then(res => {
                const found = Array.isArray(res.data) && res.data.some(p => p.project_role === "voorman");
                setIsVoorman(found);
            })
            .catch((err) => {
                setIsVoorman(false)
            })
            .finally(() => setLoading(false));
    }, [auth.userId]);

    return { isVoorman, loading };
}

